import React, {Component} from 'react';
import CoursesMassUpdateView from "../views/CoursesMassUpdateView";
import {
  STEP_MASSUPDATE_SELECT,
  STEP_MASSUPDATE_SUCCESS,
  OPERATION_GROUP,
  OPERATION_SELECTED, LANGUAGE_EN
} from "../../../constants";
import qs from "qs";
import i18n from "../../../i18n";
import {
  FormUtility,
  withAuthentication,
  withCourseGroupsApi,
  withCoursePortalApi,
  withCourseStatisticsApi,
  withRouter
} from "cw-styleguide-react";

class CoursesMassUpdateController extends Component {

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    let selectedCourses = qs.parse(this.props.location.search, {ignoreQueryPrefix: true}).courses;

    if (selectedCourses === Object(selectedCourses)) {
      selectedCourses = Object.values(selectedCourses)
    }

    console.log('SELECTED', selectedCourses)
    // Set the initial state of the form filter values.
    this.state = {
      inputLanguage: LANGUAGE_EN,
      selected: new Set(),
      courseGroup: null,
      courseGroupName: null,
      courseGroupType: null,
      courseCount: null,
      step: STEP_MASSUPDATE_SELECT,
      messages: new Set(),
      loaded:false,
      values: {
        'reviewDate': null,
        'status': null,
        'content': '',
        'summary': '',
        'entry': '',
        'enrolment': '',
        'cost': '',

      },
      formErrors: [],
      selectedCourses: selectedCourses ? selectedCourses : []
    }
    this.handleSetStep = this.handleSetStep.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.handleSubmitSelected = this.handleSubmitSelected.bind(this);
    this.handleSubmitGroup = this.handleSubmitGroup.bind(this);
    this.handleSetFormValue = this.handleSetFormValue.bind(this);
    this.loadCourseGroup = this.loadCourseGroup.bind(this);

  }

  /**
   * handleSetStep.
   * @param e
   * @param step
   */
  handleSetStep(e, step) {
    e.preventDefault();

    this.setState({
      step: step,
      messages: new Set(),
      formErrors: []
    });
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {

    if (this.props.params.courseGroup) {
      this.loadCourseGroup(this.props.params.courseGroup);
    } else {
      this.setState({
        loaded: true
      });
    }

  }

  loadCourseGroup(id) {
    this.props.courseGroupsApiGetCourseGroups([id], i18n.language, (response) => {

      this.setState({
        courseGroupType: response.data[0].courseGroupType,
        courseGroup: response.data[0].id,
        courseGroupName: response.data[0].courseGroupName,
      });

      this.props.courseStatisticsApiGetQ(response.data[0].id, i18n.language, (response) => {
        this.setState({
          courseCount: response.data.total,
          loaded:true
        })
      }, (error) => {
      });
    }, (error) => {
    });
  }

  /**
   * Handle the bulk selection of venue checkboxes.
   * @param event
   */
  handleSelected(event) {

    const selected = this.state.selected;
    if (selected.has(event.target.value)) {
      selected.delete(event.target.value);
    } else {
      selected.add(event.target.value);
    }
    this.setState({
      selected: selected
    });

  }

  /**
   * Handle field onChange events and save to the state.
   * @param event
   */
  handleChange(event) {
    const values = {...this.state.values};
    this.setState({
      values: FormUtility.setFormValues(event, values)
    });
  }

  /**
   * handleSetFormValue.
   * @param field
   * @param value
   */
  handleSetFormValue(field, value) {
    const values = {...this.state.values};
    values[field] = value;
    this.setState({
      values: values
    });
  }

  /**
   * Communal submit function for the two different type of mass updating.
   * @param type
   */
  handleSubmit(type) {

    console.log('MASS UPDATE', this.state.selectedCourses);

    // Start off with a blank set of messages.
    let messages = new Set();

      let payload = {};
      if (this.state.selected.has('content')) {
        payload['content'] = this.state.values.content;
      }
      if (this.state.selected.has('summary')) {
        payload['summary'] = this.state.values.summary;
      }
      if (this.state.selected.has('entry')) {
        payload['entry'] = this.state.values.entry;
      }
      if (this.state.selected.has('enrolment')) {
        payload['enrolment'] = this.state.values.enrolment;
      }
      if (this.state.selected.has('entry')) {
        payload['entry'] = this.state.values.entry;
      }
      if (this.state.selected.has('cost')) {
        payload['cost'] = this.state.values.cost;
      }
      payload['reviewDate'] = this.state.values.reviewDate;
      payload['status'] = this.state.values.status;

      if (type === OPERATION_SELECTED) {

       this.props.coursePortalApiPutCourseList(this.state.selectedCourses, payload, i18n.language, (response) => {

         messages.add({
           'type': 'positive',
           "message": i18n.t('local:view.courses.massUpdate.messages.success', {"count": response.data.courseId.length})
         });
         this.setState(
           {
             "messages": messages,
             formErrors: [],
             "step": STEP_MASSUPDATE_SUCCESS
           }
         );

       }, (error) => {
         this.setState(FormUtility.processServerErrors(error, i18n));
         // If the error status code is 409 then proceed to the last step
         if (error.response.status == 409) {
           this.setState(
               {
                 "step": STEP_MASSUPDATE_SUCCESS
               }
           );
         }
       });
      } else {
        this.props.coursePortalApiPutCourseGroup([this.state.courseGroup], payload, i18n.language, (response) => {

          messages.add({
            'type': 'positive',
            "message": i18n.t('local:view.courses.massUpdate.messages.success', {"count": response.data.courseId.length})
          });
          this.setState(
            {
              "messages": messages,
              formErrors: [],
              "step": STEP_MASSUPDATE_SUCCESS
            }
          );

        }, (error) => {
          this.setState(FormUtility.processServerErrors(error, i18n));
          // If the error status code is 409 then proceed to the last step
          if (error.response.status == 409) {
            this.setState(
                {
                  "step": STEP_MASSUPDATE_SUCCESS
                }
            );
          }
        });
      }


  }

  /**
   * handleSubmitSelected
   * @param event
   */
  handleSubmitSelected(event) {
    event.preventDefault();
    this.handleSubmit(OPERATION_SELECTED);
  }

  /**
   * handleSubmitGroup
   * @param event
   */
  handleSubmitGroup(event) {
    event.preventDefault();
    this.handleSubmit(OPERATION_GROUP);
  }

  /**
   * render
   * @returns {JSX.Element}
   */
  render() {

    return <CoursesMassUpdateView {...this.state} query={this.props.query}
                                  operation={this.props.operation}
                                  handleSetStep={this.handleSetStep}
                                  handleSelected={this.handleSelected}
                                  handleSetInputLanguage={this.handleSetInputLanguage}
                                  handleSubmitGroup={this.handleSubmitGroup}
                                  handleSubmitSelected={this.handleSubmitSelected}
                                  handleChange={this.handleChange}
                                  handleSetFormValue={this.handleSetFormValue}
    />;
  }
}

export default withRouter(withCourseStatisticsApi(process.env)(withCourseGroupsApi(process.env)(withCoursePortalApi(process.env)(withAuthentication(CoursesMassUpdateController)))));
